import { useWindowShell } from '@krp/client-runtime'
import { AQSI_WINDOWS } from '@krp/resource-aqsi-ui'
import { ONEC_RECEIPT_WINDOWS } from '@krp/resource-onec-ui'
import { OWN_JOURNAL_WINDOWS } from '@krp/resource-receipts-ui'
import { StatusMessage } from '@krp/ui-kit'
import { ReceiptLinesBinding } from '../aqsi/ReceiptLinesBinding'
import { CashReceiptLinesBinding } from '../onec/CashReceiptLinesBinding'
import { OwnReceiptLinesBinding } from './OwnReceiptDetailBinding'

/**
 * Товары чека под раскрытой строкой списка, где смешаны чеки разных источников (статистика магазина, отчёт кассира). Адрес чека
 * (`originalPath`) отдала служба; по нему находится окно чека источника, а здесь показываются ровно его товары — тем же запросом.
 */
export function ReceiptLinesByPath({ originalPath }: { originalPath: string }) {
  const target = useWindowShell().match(originalPath)
  const params: Readonly<Record<string, string | undefined>> = target?.params ?? {}
  const rid = params.rid ?? ''
  switch (target?.kind) {
    case ONEC_RECEIPT_WINDOWS.receipt: return <CashReceiptLinesBinding resourceId={rid} kind={params.kind} receiptKey={params.key ?? ''} />
    case AQSI_WINDOWS.receipt: return <ReceiptLinesBinding resourceId={rid} receiptId={params.key ?? ''} />
    case OWN_JOURNAL_WINDOWS.detail: return <OwnReceiptLinesBinding resourceId={rid} id={params.id ?? ''} />
    default: return <StatusMessage kind="empty" title="Содержимое чека здесь недоступно" text="Источник не зарегистрировал окно исходного чека." />
  }
}
